'use strict';
import {module} from '../app';

module.filter('reverse', function () {
    return function (items) {
      if (!items) {
        return items;
      }
      return items.slice().reverse();
    };
  });



// WEBPACK FOOTER //
// ./src/scripts/directives/reverse.js